
import { Routes } from "@angular/router";
import { BasicSetting } from "@pages/basic-setting/basic-setting";
import { ConfirmPasswordComponent } from "@pages/confirm-password/confirm-password.component";
import { CustomerList } from "@pages/customer-list/customer-list";
import { Dashboard } from "@pages/dashboard/dashboard";
import { ChangeSuccess } from "@pages/login/change-success/change-success";
import { ForgetPassword } from "@pages/login/forget-password/forget-password";
import { Login } from "@pages/login/login";
import { ResetPassword } from "@pages/login/reset-password/reset-password";
import { SupportSettings } from "@pages/support-settings/support-settings";

import { XRayDetailNew } from "@pages/x-ray-detail-new/x-ray-detail-new";
import { XRayList } from "@pages/x-ray-list/x-ray-list";
import { XRayNew } from "@pages/x-ray-new/x-ray-new";
import { AuthGuard } from "@routing/auth-guard";
import { SetPasswordGuard } from "@routing/set-password-guard";
import { DefaultLayout } from "@shared-components/default-layout";
import { AppRoutes } from "@utils/constants";  // import constants for routing

export const routes: Routes = [
  { path: AppRoutes.DEFAULT, redirectTo: AppRoutes.LOGIN, pathMatch: "full" },
  {
    path: AppRoutes.LOGIN,
    component: Login,
  },
  { path: AppRoutes.REGISTRATION, component: ConfirmPasswordComponent },
  {
    path: 'set-password/:anything',
    component: ConfirmPasswordComponent,
    canActivate: [SetPasswordGuard]
  },
  {
    path: AppRoutes.FORGET_PASSWORD,
    component: ForgetPassword,
  },
  {
    path: AppRoutes.RESET_PASSWORD,
    component: ResetPassword,
  },
  {
    path: AppRoutes.SUCCESS,
    component: ChangeSuccess,
  },
  {
    path: AppRoutes.DASHBOARD,
    component: DefaultLayout,
    canActivate: [AuthGuard], // Apply AuthGuard to this route
    data: {
      title: AppRoutes.DASHBOARD,
    },
    children: [
      {
        path: AppRoutes.DEFAULT,
        component: Dashboard,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.CUSTOMER_LIST,
        component: CustomerList,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.XRAY_NEW,
        component: XRayNew,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.XRAY_LIST,
        component: XRayList,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.XRAY_DETAIL_NEW,
        component: XRayDetailNew,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.BASIC_SETTING,
        component: BasicSetting,
      },
      {
        path: AppRoutes.DASHBOARD_CHILDREN.SUPPORT_SETTINGS,
        component: SupportSettings,
      },
    ],
  },
];
